import { BREAKPOINTS, SPACING } from "../../../utils/constants";

// Set by the densest table (Holdings) so every section flips to cards together rather than in a staircase.
export const SECTION_CARD_BREAKPOINT = BREAKPOINTS.tabletLarge;

export const SECTION_GAP = SPACING.md - SPACING.xxs;

// The scroll container starts behind the fixed 52px top nav, so sticky offsets have to clear it.
export const TOP_NAV_HEIGHT = SPACING.xxl + SPACING.xs;

// The rail region each holdings row points `aria-controls` at; the heading names it instead.
export const CONTEXT_RAIL_PANEL_ID = "position-insight-panel";

export const CONTEXT_RAIL_HEADING_ID = "position-insight-heading";

export const INLINE_POSITION_INSIGHT_ID = "inline-position-insight";

export const INLINE_POSITION_INSIGHT_HEADING_ID =
  "inline-position-insight-heading";

export const inspectButtonIdOf = (holdingId: number) =>
  `holding-inspect-${holdingId}`;

// A transient section failure is retried with the same pair on this cadence while its last payload stays up.
export const SECTION_RETRY_DELAY_MS = 5000;

// Stale restarts past this many in a row wait SECTION_RETRY_DELAY_MS before re-reading the summary.
export const IMMEDIATE_RESTARTS = 2;
